import "../styles/globals.css";
import { ThemeProvider } from "next-themes";
import Layout from "../components/layout";
import { Provider } from "react-redux";
import { store } from "../redux/store";
import { useRouter } from "next/router";
import { MetaMaskProvider } from "metamask-react";
import Meta from "../components/Meta";
import UserContext from "../components/UserContext";
import {useRef, useEffect, useState} from "react";
import {getToken} from "../utils/jwtUtil";
import {AuthProvider, hasAuthParams, useAuth} from "react-oidc-context";
import {InMemoryWebStorage, WebStorageStateStore} from "oidc-client-ts";

if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap");
}

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const pid = router.asPath;
  const scrollRef = useRef({
    scrollPos: 0,
  });
  const currentUrl = typeof window !== "undefined" ? window.location.origin : "";

  const cognitoAuthConfig = {
    authority: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_ZAn0QVMcW",
    client_id: "uncfkh6mf62lqi1kjfh6l1749",
    redirect_uri: currentUrl, //"http://localhost:3000"
    response_type: "code",
    scope: "openid", //aws.cognito.signin.user.admin email openid phone profile
    automaticSilentRenew: true,
    onSigninCallback: async (user) => {
      if (user) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    },
    onSignoutCallback: async() => {
      const clientId = "uncfkh6mf62lqi1kjfh6l1749";
      const logoutUri = currentUrl;//"http://localhost:3000"; //"https://portal.carbonpumpit.co"; 
      const cognitoDomain = "https://cp.auth.eu-west-1.amazoncognito.com";
      window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
    }
  };
  
  return (
    <>
      <Meta title="CarbonPump" />

      <Provider store={store}>
        <ThemeProvider enableSystem={true} attribute="class">
          <MetaMaskProvider>
            <AuthProvider 
                {...cognitoAuthConfig}
                userStore={
                  new WebStorageStateStore({
                    store: globalThis?.window?.localStorage ?? InMemoryWebStorage,
                  })
                }>
              <UserContext.Provider value={{ scrollRef: scrollRef }}>
                {pid === "/login" ? (
                  <Component {...pageProps} />
                ) : (
                  <Layout>
                    <Component {...pageProps} />
                  </Layout>
                )}
              </UserContext.Provider>
            </AuthProvider>
          </MetaMaskProvider>
        </ThemeProvider>
      </Provider>
    </>
  );
}

export default MyApp;